var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExecutiveSummaryEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09 9H16l4 3h24.91c1.154 0 2.09.895 2.09 2v31c0 1.105-.936 2-2.09 2H3.09C1.937 47 1 46.105 1 45V11c0-1.105.936-2 2.09-2z",
    stroke: "#2266E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21.84c0-1.017-.936-1.84-2.09-1.84H20l-4-3H3.09C1.937 17 1 17.823 1 18.84M1 14V2.84C1 1.822 1.936 1 3.09 1H16l4 3h24.91C46.063 4 47 4.823 47 5.84v9.66",
    stroke: "#2266E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 33,
    r: 2,
    fill: "#2266E3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 33,
    r: 2,
    fill: "#2266E3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 33,
    r: 2,
    fill: "#2266E3"
  })));
}
export default SvgExecutiveSummaryEmptyState;